// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","419":"15e9046c","455":"a08a12fe","578":"97bc48dc","670":"72fb0fc7","977":"4dc61a07"}[chunkId] + ".chunk.js";
};